/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import usePrevious from '../../../hooks/usePrevious';
import { useSpring, animated, config } from 'react-spring';
import { isIE } from '../../../utils';
import './styles.css';

export const RoscoSVG = props => {
  const perimAct = 2 * Math.PI * props.rAct;
  const perimAnt = 2 * Math.PI * props.rAnt;
  const perimAntAnt = 2 * Math.PI * props.rAntAnt;

  const porcAct = 2 * Math.PI * props.rAct * props.porcentAct;
  const porcAnt = 2 * Math.PI * props.rAnt * props.porcentAnt;
  const porcAntAnt = 2 * Math.PI * props.rAntAnt * props.porcentAntAnt;

  const vBWidth = 2 * props.centx;
  const vBHeight = 2 * props.centy;

  const prevPorcAct = usePrevious(porcAct) || 0;
  const prevPorcAnt = usePrevious(porcAnt) || 0;
  const prevPorcAntAnt = usePrevious(porcAntAnt) || 0;

  const springAct = useSpring({
    from: { strokeDashoffset: perimAct - prevPorcAct },
    to: { strokeDashoffset: perimAct - porcAct },
    config: config.default,
  });
  const springAnt = useSpring({
    from: { strokeDashoffset: perimAnt - prevPorcAnt },
    to: { strokeDashoffset: perimAnt - porcAnt },
    config: config.default,
  });
  const springAntAnt = useSpring({
    from: { strokeDashoffset: perimAntAnt - prevPorcAntAnt },
    to: { strokeDashoffset: perimAntAnt - porcAntAnt },
    config: config.default,
  });

  const mencyrAct = props.centy - props.rAct;
  const mencyrAnt = props.centy - props.rAnt;
  const mencyrAntAnt = props.centy - props.rAntAnt;
  const mascxrAct = props.centx + props.rAct;
  const mascxrAnt = props.centx + props.rAnt;
  const mascxrAntAnt = props.centx + props.rAntAnt;

  const pathIn = `M ${props.centx}, ${mencyrAnt} A ${props.rAnt} ${
    props.rAnt
  } 0 1 1 
    ${props.centy} ${mascxrAnt} A ${props.rAnt} ${props.rAnt} 0 1 1 ${
    props.centx
  } ${mencyrAnt}`;
  const pathOut = `M ${props.centx}, ${mencyrAct} A ${props.rAct} ${
    props.rAct
  } 0 1 1 
    ${props.centy} ${mascxrAct} A ${props.rAct} ${props.rAct} 0 1 1 ${
    props.centx
  } ${mencyrAct}`;
  const pathAntAnt = `M ${props.centx}, ${mencyrAntAnt} A ${props.rAntAnt} ${
    props.rAntAnt
  } 0 1 1 
    ${props.centy} ${mascxrAntAnt} A ${props.rAntAnt} ${props.rAntAnt} 0 1 1 ${
    props.centx
  } ${mencyrAntAnt}`;

  const animateRefs = React.useRef([]);
  React.useEffect(() => {
    for (const animateRef of animateRefs.current) {
      if (animateRef != null) {
        animateRef.beginElement();
      }
    }
  });

  //Quitamos la animacion de IE. IE no se entera de que cambiamos la propiedad del svg y no hace update automaticamente
  //se podría forzar updates del svg manualmente
  const willAnimate = !isIE();
  return (
    <svg
      width={props.rAct}
      height={props.rAct}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      viewBox={`0 0 ${vBWidth} ${vBHeight} `}
    >
      <g strokeWidth={2}>
        <circle stroke={props.strokeAct} cx={props.centx} cy={props.centy} r={props.rAct} />
        <circle stroke={props.strokeAnt} cx={props.centx} cy={props.centy} r={props.rAnt} />
        <circle stroke={props.strokeAntAnt} cx={props.centx} cy={props.centy} r={props.rAntAnt} />
      </g>
      <g strokeLinecap={props.strokeLinecap}>
        {willAnimate ? (
          <>
            <animated.path
              d={pathOut}
              stroke={props.strokeAct}
              strokeWidth={props.strokeWidthOut}
              strokeDasharray={perimAct}
              {...springAct}
              id="circle1"
            />
            <animated.path
              d={pathIn}
              stroke={props.strokeAnt}
              strokeWidth={props.strokeWidthIn}
              strokeDasharray={perimAnt}
              {...springAnt}
              class="circle2"
            />
            <animated.path
              d={pathAntAnt}
              stroke={props.strokeAntAnt}
              strokeWidth={props.strokeWidthIn}
              strokeDasharray={perimAntAnt}
              {...springAntAnt}
              class="circle2"
            />
          </>
        ) : (
          <>
            <path
              d={pathOut}
              stroke={props.strokeAct}
              strokeWidth={props.strokeWidthOut}
              strokeDasharray={perimAct}
              strokeDashoffset={perimAct - porcAct}
            />
            <path
              d={pathIn}
              stroke={props.strokeAnt}
              strokeWidth={props.strokeWidthIn}
              strokeDasharray={perimAnt}
              strokeDashoffset={perimAnt - porcAnt}
            />
            <path
              d={pathAntAnt}
              stroke={props.strokeAntAnt}
              strokeWidth={props.strokeWidthIn}
              strokeDasharray={perimAntAnt}
              strokeDashoffset={perimAntAnt - porcAntAnt}
            />
          </>
        )}
      </g>
    </svg>
  );
};
